import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import UsersGridLayout from './containers/Grid'

export default function UserLayout() {
  return <Router>
    <PrivateRoute path="/settings/users" component={UsersGridLayout} />
  </Router>
}
